(() => {
  const init = () => {
    const route = document.body.dataset.pcPage || 'index';
    const page = route.replace(/\.html$/, '');
    const esc = s => String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const projectUrl = (fields = {}) => '/pages/project-customization?' + new URLSearchParams(fields).toString() + '#project-brief';
    const applications = [
      ['Hotels & resorts', '/pages/commercial-hospitality', 'Hotel or resort'],
      ['Restaurants & cafés', '/pages/commercial-dining', 'Restaurant or café'],
      ['Pool & beach clubs', '/pages/commercial-poolside', 'Pool or beach club'],
      ['Parks & shared spaces', '/pages/commercial-public-spaces', 'Public or shared space']
    ];
    document.querySelectorAll('.main-nav').forEach(nav => {
      let group = [...nav.querySelectorAll('.has-menu')].find(el => /Commercial/.test(el.textContent));
      if (!group) {
        const anchor = [...nav.querySelectorAll(':scope > a')].find(el => /commercial(?:\.html)?$/.test(el.getAttribute('href')));
        if (anchor) {group = document.createElement('div');group.className = 'nav-item has-menu';anchor.replaceWith(group);}
      }
      if (group) {
        group.innerHTML = '<button class="nav-trigger" type="button" aria-expanded="false">Commercial <span>+</span></button><div class="mega-menu"><a href="/pages/commercial">Commercial overview</a>'+applications.map(a => '<a href="'+a[1]+'">'+esc(a[0])+'</a>').join('')+'<a class="project-services-link" href="/pages/project-customization">Project customization</a></div>';
        const button = group.querySelector('button');
        button.addEventListener('click', () => {const open=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded', String(open));group.classList.toggle('is-expanded',open);});
        group.addEventListener('keydown', e => {if(e.key==='Escape'){group.classList.remove('is-expanded');button.setAttribute('aria-expanded','false');button.focus();}});
      }
    });
    document.querySelectorAll('.header-cta').forEach(a=>{a.href='/pages/project-customization#project-brief';a.textContent='Start a project';});
    const callout = (heading, body, linkText, href) => {
      const section=document.createElement('section');section.className='project-callout';
      section.innerHTML='<div><h2>'+heading+'</h2><p>'+body+'</p></div><a class="button button-dark" href="'+href+'">'+linkText+'</a>';
      return section;
    };
    if (page==='commercial') {
      document.querySelectorAll('.solution-card').forEach((card,i)=>{
        if(!applications[i])return;
        card.id=['hospitality','dining','poolside','public-spaces'][i];
        const a=card.querySelector('a');if(a){a.href=applications[i][1];a.textContent='Explore this application';}
      });
      const main=document.querySelector('main');
      if(main)main.append(callout('A project of your own?','Configure the product mix, dimensions and finish around your space. Share the project location, estimated quantities and target schedule.','Explore project customization','/pages/project-customization'));
      const terrace=document.querySelector('.split-feature .button');if(terrace)terrace.href=projectUrl({type:'Hotel or resort'});
    }
    if(page==='residential'){
      document.querySelectorAll('.solution-card').forEach((card,i)=>{card.id=['garden','poolside','balconies','outdoor-kitchen'][i];});
    }
    if(page==='index'){
      const oem=document.querySelector('#oem');
      if(oem)oem.after(callout('Your space. Your specification.','Explore project customization for hospitality, dining, poolside and shared outdoor spaces.','Plan a commercial project','/pages/project-customization'));
    }
    if(page==='oem-design'){
      const main=document.querySelector('main');
      if(main)main.append(callout('Specifying for a particular site?','Define the furniture mix, material direction and quantities for your commercial space in a focused project brief.','Start a project brief','/pages/project-customization#project-brief'));
    }
    if(page==='hipswood'){
      document.querySelectorAll('a[href="/pages/contact"]').forEach(a=>{if(/sample|finish/i.test(a.textContent))a.href=projectUrl({request:'Physical finish samples'});});
      document.querySelectorAll('.finish-swatch').forEach(card=>{
        const code=card.querySelector('b')?.textContent.trim();if(!code)return;
        const a=document.createElement('a');a.className='finish-request';a.href=projectUrl({finish:code,request:'Physical finish samples'});a.textContent='Request this sample';card.append(a);
      });
    }
    if(page==='collections'){
      const list=document.querySelector('.catalogue-list');
      if(list){
        const controls=document.createElement('div');controls.className='collection-filter';controls.setAttribute('aria-label','Filter collection groups');
        controls.innerHTML=['All','Commercial','Residential'].map((name,i)=>'<button class="project-outline" type="button" aria-pressed="'+(i===0)+'" data-market="'+name+'">'+name+'</button>').join('');
        list.before(controls);
        controls.addEventListener('click', e=>{
          const b=e.target.closest('button[data-market]');if(!b)return;
          controls.querySelectorAll('button').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));
          list.querySelectorAll('.catalogue-row').forEach(row=>{row.hidden=b.dataset.market!=='All'&&!row.querySelector('span').textContent.toLowerCase().includes(b.dataset.market.toLowerCase());});
        });
      }
      document.querySelector('main')?.append(callout('Turn your shortlist into a specification.','Select models in Product Motion, then carry their codes into your project brief with one click.','Build a model shortlist','/pages/product-motion'));
    }
    // This is a visitor's temporary draft, not an enquiry database.
    let shortlist=[];
    try {shortlist=JSON.parse(sessionStorage.getItem('polycobondProjectShortlist')||'[]');if(!Array.isArray(shortlist))shortlist=[];}catch{}
    shortlist=shortlist.filter(x=>typeof x==='string'&&/^[A-Z0-9 \-大小]{3,30}$/.test(x)).slice(0,30);
    if(page==='motion-library'){
      const grid=document.querySelector('#motionGrid');
      if(grid){
        const panel=document.createElement('div');panel.className='project-shortlist-panel';panel.setAttribute('aria-live','polite');grid.before(panel);
        const update=()=>{
          panel.replaceChildren();
          const p=document.createElement('p');p.textContent=shortlist.length ? shortlist.length+' models selected: '+shortlist.join(', ') : 'Select up to 30 models for your project brief.';
          const a=document.createElement('a');a.href=projectUrl({models:shortlist.join(', ')});a.textContent='Continue to project brief';
          panel.append(p,a);try{sessionStorage.setItem('polycobondProjectShortlist',JSON.stringify(shortlist));}catch{}
        };
        grid.querySelectorAll('.motion-card').forEach(card=>{
          const model=card.dataset.code || card.querySelector('h3')?.textContent.trim();
          if(!model)return;
          const button=document.createElement('button');button.type='button';button.className='project-shortlist-button';
          const state=()=>{const active=shortlist.includes(model);button.textContent=active?'Remove from shortlist':'Add to shortlist';button.setAttribute('aria-pressed',String(active));};
          button.addEventListener('click',()=>{if(shortlist.includes(model))shortlist=shortlist.filter(x=>x!==model);else if(shortlist.length<30)shortlist.push(model);else {panel.querySelector('p').textContent='Your shortlist contains 30 models. Remove a model to add another.';return;}state();update();});
          card.querySelector('.motion-card-copy').append(button);state();
        });update();
      }
    }
    const form=document.querySelector('#projectBriefForm');
    if(form){
      const params=new URLSearchParams(location.search);
      const type=params.get('type');if(type&&[...form.querySelector('#projectType').options].some(o=>o.value===type))form.querySelector('#projectType').value=type;
      form.querySelector('#projectModels').value=(params.get('models')||shortlist.join(', ')).slice(0,800);
      form.querySelector('#projectFinish').value=[params.get('finish'),params.get('request')].filter(Boolean).join(' / ').slice(0,300);
      const status=form.querySelector('#briefStatus');
      const brief=()=> 'POLYCOBOND PROJECT BRIEF\n\n'+[...new FormData(form)].filter(([k,v])=>k.startsWith('contact[')&&String(v).trim()).map(([k,v])=>k.slice(8,-1)+': '+String(v).trim()).join('\n')+'\n\nPlease advise on suitable models, finish samples and the next steps.';
      const showFallback=text=>{form.querySelector('#briefFallbackLabel').hidden=false;const area=form.querySelector('#briefFallback');area.value=text;area.focus();area.select();};
      form.querySelector('#copyProjectBrief').addEventListener('click',async()=>{
        const text=brief();try{await navigator.clipboard.writeText(text);status.textContent='Brief copied. Paste it into an email to info@polycobond.com.';}catch{showFallback(text);status.textContent='Select and copy the brief below, then paste it into your email.';}
      });
      form.querySelector('#downloadProjectBrief').addEventListener('click',()=>{
        const url=URL.createObjectURL(new Blob([brief()],{type:'text/plain;charset=utf-8'})),a=document.createElement('a');a.href=url;a.download='Polycobond-project-brief.txt';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);status.textContent='Brief saved as a text file. Attach it to your email to info@polycobond.com.';
      });
    }
    // Keep the existing mail-client forms accurate about what the button does.
    document.querySelectorAll('#inquiryForm,#catalogueForm').forEach(form=>{
      const submit=form.querySelector('[type="submit"]');if(submit)submit.textContent='Send enquiry';
      const note=form.querySelector('.form-note');if(note)note.textContent='Submit your enquiry to the Polycobond team.';
      const link=document.createElement('a');link.href='/pages/project-customization#project-brief';link.className='finish-request';link.textContent='Use the detailed project brief';form.append(link);
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

// Native Shopify form submission feedback; never intercept submission or CAPTCHA.
(() => {
  const init = () => {
    document.querySelectorAll('#inquiryForm,#catalogueForm,#projectBriefForm').forEach(form => {
      if (form.dataset.submitFeedbackInit) return;
      form.dataset.submitFeedbackInit = 'true';
      let timer;
      const clearTimer = () => { clearTimeout(timer); timer = undefined; };
      window.addEventListener('pagehide', clearTimer);
      form.addEventListener('submit', () => {
        clearTimer();
        let status = form.querySelector('.pc-submit-status');
        if (!status) {
          status = document.createElement('p');
          status.className = 'pc-submit-status';
          status.setAttribute('role', 'status');
          status.setAttribute('aria-live', 'polite');
          status.style.cssText = 'margin-top:12px;font-size:14px;line-height:1.5';
          form.append(status);
        }
        status.textContent = 'Submitting your enquiry. Please complete any verification shown.';
        timer = setTimeout(() => {
          status.textContent = 'Submission has not been confirmed yet. Please complete any verification shown. If this page does not continue, you can email ';
          const email = document.createElement('a');
          email.href = 'mailto:info@polycobond.com';
          email.textContent = 'info@polycobond.com';
          status.append(email, ' directly.');
        }, 15000);
      }, true);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
